import { Breadcrumb } from "antd";
import React from "react"
import { useState } from "react"
import OrderCustomerScreen from "./OrderCustomerScreen";
import OrderSelectContactScreen from "./OrderSelectContactScreen";
import OrderSearchScreen from "../bnordersearch/OrderSearchScreen";
import { getCurrenciesDenominationsByCustomer } from "../../networking/NetworkingCurrencies";
import OrderInformationScreen from "./OrderInformationScreen";
import useLookUpTables from "../maintenance/complaints/useLookUpTables";
import OrderSummary from "./OrderSummary";
import { getDefaultAddress } from "../../networking/NetworkingAddresses";
import { useEffect } from "react";
import { getBNVaults, getOrderInfo } from "../../networking/NetworkingOrders";
import { DenominationTypes } from "../../constants/DenominationTypes";
import { getDeliveryMethods } from "../../networking/NetworkingBankNotes";
import { getInstrumentsByCustomer } from "../../networking/NetworkingInstruments";
import { getTradingInformationByCustomerID } from "../../networking/NetworkingCustomers";
import AlertBox from "../shared/AlertBox";
import { getEntityProperties } from "../../networking/NetworkingEntityProperties";
import { equalsIgnoreCase } from "../../helpers/StringHelper";
import { useCallback } from "react";

class RatesStore {
    constructor(initial = {}) {
        this.currencies = new Map(Object.entries(initial));
    }

    set(key, value) {
        this.currencies.set(key, value);
    }

    get(key) {
        return this.currencies.get(key);
    }

    update(key, updates) {
        //const key = currency.toLowerCase();
        const current = this.currencies.get(key) ?? {};

        const updated = {
            ...current,
            ...updates,
        };

        this.currencies.set(key, updated);

        return updated;
    }

    toJSON() {
        return Object.fromEntries(this.currencies);
    }
}

export const OrderContext = React.createContext({});

const  OrderScreen = ({buySellSide, orderSearchID, updateOrderSearchID}) => {
    const [step, setStep] = useState(1);
    const companyAddress = localStorage.getItem('BNCompany Address');
    const [buyCurrency, setBuyCurrency] = useState('');
    const [buyCurrencyScale, setBuyCurrencyScale] = useState(2);
    const [buyCurrencySymbol, setBuyCurrencySymbol] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [objCustomer, setObjCustomer] = useState({});
    const [customerType, setCustomerType] = useState('');
    const [objContact, setObjContact] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const baseCCy= localStorage.getItem('BNBase Currency');
    const [reload, setReload] = useState(false);
    const [showCostRate, setShowCostRate] = useState(false);
    const [editCostRate, setEditCostRate] = useState(false);
    const [editCustomerRate, setEditCustomerRate] = useState(false);
    const screenPermisions = JSON.parse(localStorage.getItem('ScreenShowPermissions'));
    const [crossRate, setCrossRate] = useState(0);
    const [instruments, setInstruments] = useState([]);
    const [settlementMethods, setSettlementMethods] = useState([]);
    const [defaultInstrument, setDefaultInstrument] = useState('');
    const [defaultSettlementMethod, setDefaultSettlementMethod] = useState('');    
    const [defaultSettlementCurrency, setDefaultSettlementCurrency] = useState('');    
    const [originalTotalOrder, setOriginalTotalOrder] = useState(false);
    const [originalDeliveryMethod, setOriginalDeliveryMethod] = useState(false);
    const [allowOrderCurrentDate, setAllowOrderCurrentDate] = useState(false);
    const [saveOrderWithLoss, setSaveOrderWithLoss] = useState(false);
    const [vaults, setVaults] = useState([]);
    const [refreshRates, setRefreshRates] = useState(false);
    const [orderScreenKey, setOrderScreenKey] = useState(0);
    const [showSpreadModal, setShowSpreadModal] = useState(false);
    const [rowCurrencyId, setRowCurrencyId] = useState('');
    const [rowSpreadID, setRowSpreadID] = useState(-1);
    const [spreadUpdatedByUser, setSpreadUpdatedByUser] = useState(false)
    const [allowBankNotesEditSpread, setAllowBankNotesEditSpread] = useState(false)
    const [buyScaleCtx, setBuyScaleCtx] = useState(2);
    //const [validEoD, setValidEoD] = useState(true);
    const [spreadChangesAccepted, setSpreadChangesAccepted] = useState(false)

    const [objOrder, setObjOrder] = useState({
        BNOrderNo:0,
         CustomerID: -1,
        UserID: '',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        DeliveryTime: '', 
        DeliveryCustomerID: 0, 
        DeliveryMethod:'',
        TotalOrder: 0, 
        TotalProfit: 0, 
        OrderFee:0,
        DenominationFee:0,
        DeliveryFee:0,
        DeliveryText:'',
        DeliveryContactName:'',
        OrderRows: [], 
        BuyCurrency:baseCCy,
        CrossRate :0,        
        SettlementInstrument:'',
        SettlementMethod:'',
        UpdateToken:'',
        VaultID:0
    });
    const [customerAddress, setCustomerAddress] = useState('');


    const [breadcrumb, setBreadbrumb] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [settlementCurrenciesList, setSettlementCurrenciesList] = useState([]);
    const [customerID, setCustomerID] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [contactID, setContactID] = useState(0);
    const [contactName, setContactName] = useState(0);
    const [deliveryMethods, setDeliveryMethods] = useState([]);
    const [existsRows, setExistsRows] = useState(false); 
    const lookUpTables = useLookUpTables('BN Settlement Delivery Method,BN Payment Delivery Method');
    const [customerDefaultDeliveryMethod, setCustomerDefaultDeliveryMethod] = useState('');
    
    const blankOrder = {
         BNOrderNo:0,
        CustomerID: 0,
        UserID: '',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        DeliveryTime: '', 
        DeliveryCustomerID: 0, 
        DeliveryMethod:'',
        TotalOrder: 0, 
        TotalProfit: 0, 
        OrderFee:0,
        DenominationFee:0,
        DeliveryFee:0,
        DeliveryText:'',
        DeliveryContactName:'',
        OrderRows: [], 
        Comments:'',
        BuyCurrency:baseCCy,
        CrossRate:0,
        SettlementInstrument:'',
        SettlementMethod:'',
        UpdateToken:'',
        VaultID:0
    }

    const [rateStore, setRateStore] = useState(new RatesStore({}))    
    const [timerIsRunning, setTimerIsRunning] = useState(false)

    useEffect(() => {        
        if (screenPermisions) {
            if (screenPermisions.ShowOrderCostRate) {
                setShowCostRate(screenPermisions.ShowOrderCostRate);
            }
            if (screenPermisions.AllowEditOrderCostRate) {
                setEditCostRate(screenPermisions.AllowEditOrderCostRate);
            }
            if (screenPermisions.AllowEditOrderCustomerRate) {
                setEditCustomerRate(screenPermisions.AllowEditOrderCustomerRate);
            }

            if (screenPermisions.SaveOrderWithLoss) {
                setSaveOrderWithLoss(screenPermisions.SaveOrderWithLoss);
            }
            if (screenPermisions.AllowOrderCurrentDate) {
                setAllowOrderCurrentDate(screenPermisions.AllowOrderCurrentDate);
            }
            if (screenPermisions.BankNotesEditSpread) {
                setAllowBankNotesEditSpread(screenPermisions.BankNotesEditSpread)
            }
        }
    }, [screenPermisions])

    const loadVaults = async()=>{
        const json = await getBNVaults();

            if(json !== undefined && json.data) {
                const vaults = json.data.map((c) => ({...c, value: c.VaultID, name: c.Address}));
                vaults.splice(0,0,{value: -1, name: "Select a vault"});
                setVaults(vaults);                
            }
    }

    useEffect(() => {
        loadVaults();
       
    }, [])

    useEffect(() => {
        async function fetchCustomerProperties() {
            let customerProperties = await getEntityProperties(customerID, 'Customer')            
            if (customerProperties && customerProperties.entityProperties && customerProperties.entityProperties.length > 0 && equalsIgnoreCase(buySellSide, 'buy')) {
                let property = customerProperties.entityProperties.find(x => equalsIgnoreCase(x.Description, 'Buy - Default Delivery Method'));
                if (property !== undefined) {                    
                    setCustomerDefaultDeliveryMethod(property.TextValue);
                }
            }
            if (customerProperties && customerProperties.entityProperties && customerProperties.entityProperties.length > 0 && equalsIgnoreCase(buySellSide, 'sell')) {
                let property = customerProperties.entityProperties.find(x => equalsIgnoreCase(x.Description, 'Sell - Default Delivery Method'));
                if (property !== undefined) {                    
                    setCustomerDefaultDeliveryMethod(property.TextValue);
                }
            }
        }
        fetchCustomerProperties()
        setRateStore(new RatesStore({}))
    }, [customerID, buySellSide]);

    useEffect(() => {
        if (customerDefaultDeliveryMethod !== '' && (objOrder.DeliveryMethod === '') ) {
            setObjOrder(prevOrder => ({
                ...prevOrder,
                DeliveryMethod: customerDefaultDeliveryMethod
            }));
        }
    }, [customerDefaultDeliveryMethod]);    

    useEffect(() => {
        if (!orderSearchID || orderSearchID === 0) return;

        const load = async () => {
            const order = await getOrderInfo(orderSearchID);
            if (order?.BNOrderNo > 0) {
                handleOrderSelected(order);
                updateOrderSearchID(0);
            }
        };

        load();
        setRateStore(new RatesStore({}))
    }, [orderSearchID]);


    useEffect(() => {

    const handleBeforeUnload = (e) => {
        if (!window.isOrderChanged) return;

        e.preventDefault();
        e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
    };
}, []);

    useEffect(() => {
        window.isOrderChanged = ((step === 3 && existsRows) || (step === 4 && (isEdit || (objOrder.BNOrderNo === null || objOrder.BNOrderNo === undefined || objOrder.BNOrderNo === 0))));

        return () => {
            window.isOrderChanged = false;
        };
    }, [step, existsRows, objOrder.BNOrderNo, isEdit]);

   /* const validateEoD = () => {

        const systemDate = localStorage.getItem('BNSystemDate')??'';
        const serverDate = localStorage.getItem('ServerDate');

        const systemDateObj = new Date(systemDate.replaceAll('-', '/'));
        const serverDateObj = new Date(serverDate);

        if(systemDateObj.getFullYear() !== serverDateObj.getFullYear() || systemDateObj.getMonth() !== serverDateObj.getMonth() || systemDateObj.getDate() !== serverDateObj.getDate()) {
            setAlertTitle('Warning');
            setAlertMessage(`The system has not yet been reconcilied and closed for ${serverDate}. Please contact your supervisor.`);
            setShowAlert(true);
            setValidEoD(false);
            return false;
        }
        return true;
    }*/

    useEffect(() => {
        if (buySellSide !== undefined) {
            //if(validateEoD())
            //{
                loadDeliveryMethods();
                setObjOrder(blankOrder);
                setStep(1);

                setRateStore(new RatesStore({}))
            /*}
            else
            {

                setStep(5);
            }*/
        }
      }, [buySellSide]);

    useEffect(()=>{
        const currencies = JSON.parse(localStorage.getItem('Currencies'));
        if(currencies)
        {
            const ccy = currencies.find(c=> c["Currency Id"] === buyCurrency)
            if(ccy)
            {
                setBuyCurrencyScale(ccy.Scale);
                setBuyCurrencySymbol(ccy.Symbol);
                setRateStore(new RatesStore({}))
            }
        }
    },[buyCurrency])

    const updateBuyCurrencyValue =(value, crossRate)=>{
        setBuyCurrency(value);
        setCrossRate(crossRate);
        setRefreshRates(true);
    }

    const loadCustomerInfo =async(customerID) =>{
        const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerID)
                
        if(currenciesResponse && currenciesResponse.currencies)
        {
            const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
            const finalCurrencies = [];
            const finalSettelementCurrencies = [];
            formattedCurrencies.forEach(element => {
            switch (element.Type) {
                case 'Payment':
                finalCurrencies.push(element);
                break;
                case 'Settlement':
                finalSettelementCurrencies.push(element);
                break;
                default:
                break;
            }
            });
            setCurrencies(finalCurrencies);
            setSettlementCurrenciesList(finalSettelementCurrencies);
        }                

        const customerAddressResponse = await getDefaultAddress(customerID);
        if(customerAddressResponse)
        {
            setCustomerAddress(`${customerAddressResponse.AddressValue}${customerAddressResponse.City ? `, ${customerAddressResponse.City}`: '' }${customerAddressResponse.CountryId ? `, ${customerAddressResponse.CountryId}`:''}`);
        }
        else
        {
            setCustomerAddress('');
        }        
        
    }

    const loadDeliveryMethods = async() => {
        const deliveryMethodsResponse = await getDeliveryMethods(buySellSide)

        if(deliveryMethodsResponse) {
            setDeliveryMethods(deliveryMethodsResponse.DeliveryMethod);
        }
    }

    const loadInstruments = async(customerID) =>{
        const instrumentsResponse = await getInstrumentsByCustomer(customerID);
        if(instrumentsResponse){
            let jsonInstruments = instrumentsResponse.instruments;
            if (jsonInstruments !== undefined) {
                var incomingHelper = [];
                let deliveryMethods = {};
                for (var i = 0; i < jsonInstruments.length; i++) {
                    let instrumentElement = {
                        value: jsonInstruments[i].Instrument,
                        name: jsonInstruments[i].Instrument
                    };
                    
                    if (jsonInstruments[i].InstrumentType === 'Incoming') {
                        incomingHelper.push(instrumentElement);
                        let list = [];
                        if(jsonInstruments[i].DeliveryMethods && jsonInstruments[i].DeliveryMethods !== ''){
                            var methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                            for(var j=0; j<methodsList.length; j++){
                                var item = {value:methodsList[j], name:methodsList[j]};
                                list.push(item);
                            }
                        }
                        deliveryMethods[jsonInstruments[i].Instrument] = list;
                    }
                }
                setInstruments(incomingHelper);
                setSettlementMethods(deliveryMethods);
            }
        }
    }

    const loadTradingInfo = async(customerID) =>{
        const response =   await getTradingInformationByCustomerID(customerID)

        if (response != null) 
        {
            if(response.DefaultSettlementInstrument !== undefined && response.DefaultSettlementInstrument !== '')
            {
                setDefaultInstrument(response.DefaultSettlementInstrument);
            }
    
            if(response.DefaultDeliveryMethod !== undefined && response.DefaultDeliveryMethod !== '')
            {
                setDefaultSettlementMethod(response.DefaultDeliveryMethod);
            }

            if(response.DefaultSettlementCurrency !== undefined && response.DefaultSettlementCurrency !== '')
            {
                setDefaultSettlementCurrency(response.DefaultSettlementCurrency);
                setBuyCurrency(response.DefaultSettlementCurrency);
            }
        }
    }

    const handleCustomerSelection = async(obj, nextStep) => {

            //Show status warning
            if (obj.Status !== 'Regular' && obj.Status !== 'Monitored') {//(obj.Status !== 'Authorized to deal') {
                nextStep = 1;
                setAlertMessage('Customer is in ' + obj.Status + ' status. Orders cannot be created or edited under this customer.');
                setAlertTitle('Warning');
                setShowAlert(true);
            }
            else
            {
                setObjCustomer(obj);
                setCustomerID(obj['Customer ID']);
                setCustomerName(obj['Customer Name']);
                setCustomerType(obj['Customer Type']);
                
                loadCustomerInfo(obj["Customer ID"]);

                loadInstruments(obj["Customer ID"]);

                if(defaultInstrument === '' || defaultInstrument === undefined || customerID !== obj['Customer ID']){
                    setDefaultInstrument(obj['DefaultSettlementInstrument$']);
                }

                if(defaultSettlementMethod === '' || defaultSettlementMethod === undefined || customerID !== obj['Customer ID']){
                    setDefaultSettlementMethod(obj['DefaultDeliveryMethod$']);
                }
            
                if(defaultSettlementCurrency === '' || defaultSettlementCurrency === undefined || customerID !== obj['Customer ID']){
                    setDefaultSettlementCurrency(obj['DefaultSettlementCurrency$']);
                    setBuyCurrency(obj['DefaultSettlementCurrency$']);
                }

                if (nextStep === 2) {                
                    setStep(nextStep);
                    setObjOrder({});
                }
        }
    }

    const handleContactSelection = (obj) => {
        setStep(3);
        setObjContact(obj);
        setContactID(obj['Contact ID']);
        setContactName(obj['Name']);
        setObjOrder({ BuyCurrency: baseCCy});
    }

    const contacts_length = (n) =>{
        if(n===0){
            setStep(1);
            setAlertTitle('Message');
            setAlertMessage('There are no active customer contacts for this customer.');
        }
    }

    const getTab = () =>{
        if (step === 1 || step === 5) {
            //if(validEoD)
            //{
                return (
                    <ul className="uk-tab">
                        <li key="step-1" className={step !== 5? 'uk-active':''}><a onClick={() => setStep(1)}>Search Customer</a></li>
                        <li key="step-5" className={step === 5? 'uk-active':''}><a onClick={() => setStep(5)}>Order Search</a></li>
                    </ul>
                );
            /*}
            else
            {
                return (
                    <ul className="uk-tab">
                        <li key="step-5" className={step === 5? 'uk-active':''}><a onClick={() => setStep(5)}>Order Search</a></li>
                    </ul>
                );
            }*/
        }
        else
            return <></>
    }

    const getBreadcrumb = () =>{
        let breadcrumb = [];
        const orderNo = (objOrder && objOrder.BNOrderNo > 0)? `: ${objOrder.BNOrderNo}`:'';
         switch (step) {
                    case 1:
                    default:
                        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() =>  setStep(1)}>{`${buySellSide} Order${orderNo}`}</Breadcrumb.Item>)   
                        break;
                    case 2:
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-order" className="breadcrumb-item" onClick={() => setStep(1)}>{`${buySellSide} Order${orderNo}`}</Breadcrumb.Item>
                                    );
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-order-cust" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{objCustomer["Customer Name"]} - Select Contact</Breadcrumb.Item>
                                    );
                        break;
                    case 5:
                        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(5)}>Order Search</Breadcrumb.Item>)  
                        break;
                    }
        return breadcrumb;
    }

    const backScreen = (obj, refresh)=>{
      setObjOrder(obj);
      setRefreshRates(refresh);
      setStep(3);
    }

    const backToSearchScreen = ()=>{
      setStep(5);
    }

    const cleanOrder = () =>{
        setObjOrder({
            ...blankOrder,
            OrderRows: []
        });
      }

    const cancelOrder = (obj)=>{
      cleanOrder();

        setStep(1);
      
    }

    const updateOrderDenominationFee = (objOrder) =>{
        
        let fee = 0;
            objOrder.OrderRows.forEach(row =>{
                let rowFee = 0;

                row.Denominations.forEach( d=>
                    rowFee += d.DenominationFee??0
                );

                row.Fee = rowFee;
                fee += rowFee;
            });            
        
      objOrder.DenominationFee = fee;
        setObjOrder(objOrder);

    }

    const updateOrderRowRate = (objOrder) =>{

        let buyAmountTotal = 0;
        let profit = 0;
            objOrder.OrderRows.forEach(row =>{
                buyAmountTotal += row.BuyAmount;
                profit += row.Profit;
            });            
        
      objOrder.TotalOrder = buyAmountTotal;
      objOrder.TotalProfit = profit;
      setObjOrder(objOrder);
      setReload(!reload);      
    }

    const updateOrderRowCostRate = (objOrder) =>{

        let profit = 0;
            objOrder.OrderRows.forEach(row =>{
                profit += row.Profit;
            });            
        
      objOrder.TotalProfit = profit;
      setObjOrder(objOrder);
      setReload(!reload);
    }

    const updateOrderFees = (objOrder, orderFee, deliveryFee) =>{
        
      objOrder.OrderFee = orderFee;
      objOrder.DeliveryFee = deliveryFee;
        setObjOrder(objOrder);

    }

    const handleOrderSelected = async(responseOrder) =>{
        if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                loadCustomerInfo(responseOrder.CustomerID);
                loadDeliveryMethods();
                loadInstruments(responseOrder.CustomerID);
                setCustomerID(responseOrder.CustomerID);
                setCustomerType(responseOrder.CustomerType);
                setCustomerName(responseOrder.Name);
                setContactID(responseOrder.ContactID);
                setContactName(responseOrder.ContactName);
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true,
                    BuyCurrency: true,
                    CrossRate: true,
                    Instrument: true,
                    SettlementMethod: true,
                    VaultID:true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedDenominations = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
                    row.AutorefreshRate = true;
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true,
                        NoteConditions: true
                    }  
                })
                setBuyCurrency(responseOrder.BuyCurrency);
                const showVaultAdd = (responseOrder.BuySell.toLowerCase() === 'buy' && responseOrder.DeliveryMethod.toLowerCase().includes('armored'));

                if(showVaultAdd)
                {
                    responseOrder.DeliveryText = responseOrder.VaultAddress;
                }


                setObjOrder(responseOrder);
                setOriginalTotalOrder(responseOrder.TotalOrder);
                setOriginalDeliveryMethod(responseOrder.DeliveryMethod);

                if(responseOrder.CanEdit)
                {
                    setIsEdit(true);
                    setStep(3);
                }
                else
                {
                    setIsEdit(false);
                    setStep(4);
                }
            }

        }
    }

    const newOrder = (orderCustomerID, orderContactID, orderCustomerName) =>{
        //if(validEoD){
            const newOrder = {
                ...blankOrder,
                CustomerID: orderCustomerID,
                OrderRows: []
            };
            setObjOrder(newOrder);
            setOrderScreenKey(prev => prev + 1);
            if(instruments.length === 0)
            {
                loadInstruments(orderCustomerID); 
                loadCustomerInfo(orderCustomerID);                  
                loadTradingInfo(orderCustomerID);         
            }
            setCustomerID(orderCustomerID);
            setContactID(orderContactID);
            setCustomerName(orderCustomerName);
            
            setStep(3);
        /*}
        else
        {
            const serverDate = localStorage.getItem('ServerDate');
            setAlertTitle('Warning');
            setAlertMessage(`The system has not yet been reconcilied and closed for ${serverDate}. Please contact your supervisor.`);
            setShowAlert(true);
            setStep(5);
        }*/
    }

    const getOrderUpdated = async(orderNo) =>{
        const responseOrder = await getOrderInfo(orderNo);
        if(responseOrder)
        {
            if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                setCustomerType(responseOrder.CustomerType);
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true,
                    BuyCurrency: true,
                    CrossRate: true,
                    Instrument: true,
                    SettlementMethod: true,
                    VaultID:true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedDenominations = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
                    row.AutorefreshRate = true;
                    
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true,
                        NoteConditions:true
                    }  
                })

                const showVaultAdd = (responseOrder.BuySell.toLowerCase() === 'buy' && responseOrder.DeliveryMethod.toLowerCase().includes('armored'));

                responseOrder.CanEdit = 0;
                if(showVaultAdd)
                {
                    responseOrder.DeliveryText = responseOrder.VaultAddress;
                }
                setObjOrder(responseOrder);
            }
        }
            setIsEdit(false);
            setStep(4);
        }
    }

    const updateOrderInfo = (obj) =>{
            setObjOrder(obj);
        }
        
    const getStepScreen = () =>{
        let screen = <></>;
         switch (step) {
                    case 1:
                    default:
                        screen = (<OrderCustomerScreen id="comp_customer_form"
                            onCustomerSelected={handleCustomerSelection} />);         
                        break;
                    case 2:
                        screen = (<OrderSelectContactScreen id="comp_contact_form"
                                        onContactSelected={handleContactSelection}
                                        contacts_length={contacts_length}
                                        objCustomer={objCustomer} />);
                        break;
                    case 3: 
                        screen = <OrderInformationScreen key={orderScreenKey} customerName={customerName} customerID={customerID} objOrder={objOrder} buyScale={buyCurrencyScale} lockedSide={buySellSide} currenciesList={currencies} updateOrder={updateOrderInfo} changeScreen={()=> setStep(4)}
                        deliveryMethodList={deliveryMethods} buyCcy={buyCurrency} crossR={crossRate} updateBuyCurrencyValue={updateBuyCurrencyValue} settlementCurrenciesList={settlementCurrenciesList} editCostRate={editCostRate} showCostRate={showCostRate} editCustomerRate={editCustomerRate}
                        backToSearchScreen={backToSearchScreen} instruments={instruments} settlementMethods={settlementMethods} defaultInstrument={defaultInstrument} defaultSettlementMethod={defaultSettlementMethod} updateExistsRows={(value)=>setExistsRows(value)} 
                        originalDeliveryMethod={originalDeliveryMethod} originalTotalOrder={originalTotalOrder} allowOrderCurrentDate={allowOrderCurrentDate} vaults={vaults} defaultSettlementCurrency={defaultSettlementCurrency}
                        refreshRates={refreshRates} resetRefreshRates={()=> setRefreshRates(false)} newOrder={newOrder} contactID={contactID} customerType={customerType} customerDefaultDeliveryMethod={customerDefaultDeliveryMethod}/>
                        break;
                    case 4:
                        screen= <OrderSummary objOrder={objOrder} buyScale={buyCurrencyScale} lockedSide={buySellSide} backScreen={backScreen} cancelOrder={cancelOrder} companyAddress={companyAddress} customerID={customerID} customerName={customerName}
                                contactID={contactID} contactName={contactName} baseCurrencySymbol={buyCurrencySymbol} customerAddress={customerAddress} updateOrderDenominationFee={updateOrderDenominationFee} updateOrderFees={updateOrderFees}
                                newOrder={newOrder} updateOrderRowRate={updateOrderRowRate} updateOrderRowCostRate={updateOrderRowCostRate} reload={reload} editCostRate={editCostRate} showCostRate={showCostRate} editCustomerRate={editCustomerRate} getOrderUpdated={getOrderUpdated}
                                saveOrderWithLoss={saveOrderWithLoss} customerType={customerType} 
                                />
                        break;
                    case 5:
                        screen = <OrderSearchScreen lockedSide={buySellSide} onOrderSelected={handleOrderSelected}/>;
                        break;
                    }
        return screen;
    }
    
    const updateCurrencyRate = (rowSpreadID, updates) => {
        setTimerIsRunning(false)
        setSpreadChangesAccepted(true)

        return rateStore.update(rowSpreadID, updates);
    };

    const contextValue = {
        showSpreadModal, setShowSpreadModal, rateStore, rowCurrencyId, setRowCurrencyId, rowSpreadID, setRowSpreadID, updateCurrencyRate, buySellSide, spreadUpdatedByUser, setSpreadUpdatedByUser,
        allowBankNotesEditSpread, buyScaleCtx, setBuyScaleCtx, timerIsRunning, setTimerIsRunning, spreadChangesAccepted, setSpreadChangesAccepted
    };
    
    return (<OrderContext.Provider value={contextValue}>
        <div className="breadcrumb-div">
            <Breadcrumb separator=">">
                {getBreadcrumb()}
            </Breadcrumb>
        </div>
        {getTab()}
        {getStepScreen()}
        <AlertBox id="warning-alert"
            open={showAlert}
            title={alertTitle}
            message={alertMessage}
            type="Ok"
            okClick={() => setShowAlert(false)}
        />
    </OrderContext.Provider>)
}

export default OrderScreen